import axios from '../Axios/Default';
import { handleResponse } from './HelperService';

const getFavorites = (params, onSuccess, onError) => {
    const response = axios.get('api/v1/user/fav', { params });
    return handleResponse(response, onSuccess, onError);
};

const getFavoriteById = (id, onSuccess, onError) => {
    const response = axios.get(`api/v1/user/fav/${id}`);
    return handleResponse(response, onSuccess, onError); 
};

const createFavorite = (payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/user/fav`, payload);
    return handleResponse(response, onSuccess, onError); 
};

const softDeleteFavorite = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/user/fav/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export { getFavorites, getFavoriteById, createFavorite, softDeleteFavorite };
